import type { FetchMeQuery } from '@salescore/client-api'
import { createContext } from 'react'

export const ErrorContext = createContext<{
  throwErrors: (_error: Error | Error[]) => void
  clearErrors: () => void
  myIdentity?: FetchMeQuery['myUser']['identity']
}>({
  throwErrors() {
    // empty
  },
  clearErrors() {
    // empty
  },
  myIdentity: undefined,
})
